const initValue = {
    key: '0',
    day: 1,
    month: 1,
    year: 2000,
    time: '00:00:00',
    event: 'событие',
    repeating: false,
    position: 'left',
    prior: 'высокий',
}

export default initValue;
